module.exports = __webpack_public_path__ + "static/media/EdmoSwiss.b5d1c09f.svg";